module.exports = __webpack_public_path__ + "static/media/hu.966f4933.svg";